// REACT
import React from 'react';

// STYLES
import styled from "styled-components";
import Colors from "../../shared/colors";

// COMPONENTS
import Dropdown from '../../components/dropdownpage/dropdownpage.component';

// CONTAINERS
import Search from '../../containers/Search/search.container';

// ICONS
import FaMapMarker from 'react-icons/lib/fa/map-marker';
import FaMap from 'react-icons/lib/fa/map';
import MdApps from 'react-icons/lib/md/apps';

export default class Box extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            view: this.props.view
        }
    }

    componentWillReceiveProps(nextProps){
        const newView = nextProps.view;

        if (this.state.view !== newView) {
            this.setState({
                view: newView
            });
        }
    }

    render(){
        const {
            to,
            setOrder,
            setView,
            order,
            t,
            i18n
        } = this.props;

        const {
            view 
        } = this.state;

        // STYLES SET
        const BtnCard = styled.div `
            width: 40px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            font-size: 29px;
            color: ${view ? Colors.primary : Colors.secondary};
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover{
                color: ${Colors.primary};
            }
        `
        const BtnMap = styled.div `
            width: 40px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            font-size: 20px;
            color: ${view === false ? Colors.primary : Colors.secondary};
            cursor: pointer;
            margin-right: 15px;
            transition: all 0.3s ease;

            &:hover{
                color: ${Colors.primary};
            }
        `
        return(
            <span>
            <BoxContent>
                <Icon>
                    <FaMapMarker/>
                </Icon>
                <SearchContent>
                    <Search to={to} order={order} i18n={i18n} t={t}/>
                </SearchContent>
                <ActionsContent>
                    {
                        (to === "restaurants" || to === "events") &&
                           
                                <ViewMode>
                                    <BtnCard onClick={() => setView()}><MdApps/></BtnCard>
                                    <BtnMap onClick={() => setView()}><FaMap/></BtnMap>
                                    {
                                        view &&
                                            <Border></Border>
                                    }
                                </ViewMode>
                    }
                    {
                        view &&
                            <Dropdown setOrder={(value) => setOrder(value)} order={order} to={to} t={t}/>
                    }
                </ActionsContent>
            </BoxContent>
                {
                    view &&
                        <OrderResponsive>
                            {/* RESTAURANTS */}
                            {
                                to === "restaurants" && 
                                    <OrderContent>
                                        <ItemOrder onClick={() => {setOrder(0)}} className={order === 0 ? 'activeOrder' : ''}>
                                            {t('Relevância')}
                                        </ItemOrder>
                                        <ItemOrder onClick={() => {setOrder(3)}} className={order === 3 ? 'activeOrder' : ''}>
                                            A-Z
                                        </ItemOrder>
                                        <ItemOrder onClick={() => {setOrder(4)}} className={order === 4 ? 'activeOrder' : ''}>
                                            Z-A
                                        </ItemOrder>
                                    </OrderContent>
                            }

                            {/* PRODUCTS */}
                            {
                                to === "products" && 
                                    <OrderContent>
                                        <ItemOrder onClick={() => {setOrder(3)}} className={order === 3 ? 'activeOrder' : ''}>
                                            A-Z
                                        </ItemOrder>
                                        <ItemOrder onClick={() => {setOrder(4)}} className={order === 4 ? 'activeOrder' : ''}>
                                            Z-A
                                        </ItemOrder>
                                    </OrderContent>
                            }

                            {/* RECEIPS */}
                            {
                                to === "recipes" && 
                                    <OrderContent>
                                        <ItemOrder onClick={() => {setOrder(3)}} className={order === 3 ? 'activeOrder' : ''}>
                                            A-Z
                                        </ItemOrder>
                                        <ItemOrder onClick={() => {setOrder(4)}} className={order === 4 ? 'activeOrder' : ''}>
                                            Z-A
                                        </ItemOrder>
                                    </OrderContent>
                            }

                            {/* EVENTS */}
                            {
                                to === "events" && 
                                    <OrderContent>
                                        <ItemOrder onClick={() => {setOrder(0)}} className={order === 0 ? 'activeOrder' : ''}>
                                            {t('Relevância')}
                                        </ItemOrder>
                                        <ItemOrder onClick={() => {setOrder(1)}} className={order === 1 ? 'activeOrder' : ''}>
                                            Recente
                                        </ItemOrder>
                                        <ItemOrder onClick={() => {setOrder(2)}} className={order === 2 ? 'activeOrder' : ''}>
                                            Antigo
                                        </ItemOrder>
                                        <ItemOrder onClick={() => {setOrder(3)}} className={order === 3 ? 'activeOrder' : ''}>
                                            A-Z
                                        </ItemOrder>
                                        <ItemOrder onClick={() => {setOrder(4)}} className={order === 4 ? 'activeOrder' : ''}>
                                            Z-A
                                        </ItemOrder>
                                    </OrderContent>
                            }
                        </OrderResponsive>
                }
            </span>

        )
    }
}


const BoxContent =  styled.div `
    width: 970px;
    height: 118px;
    background-color: #FFFFFF;
    box-shadow: 0 0 15px 0 rgba(0,0,0,0.1);
    margin-right: auto;
    margin-left: auto;
    margin-top:-59px;
    position: relative;
    z-index: 11;
    padding-left: 30px;
    padding-right: 30px;
    display:flex; 
    align-items:center;
    border-radius: 5px;

    @media screen and (max-width: 1073px) {
        width: calc(100% - 120px);
        margin-left: 30px;
        margin-right: 30px;
    } 

    @media screen and (max-width: 821px) {
        min-height: 118px;
        display: flex;
    } 

    @media screen and (max-width: 575px) {
        width: calc(100% - 90px);
        margin-right: 15px;
        margin-left: 15px;
    }
`
const SearchContent = styled.div `
    flex: 2;
`
const ActionsContent = styled.div `
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @media screen and (max-width: 830px) {
        display: none;
    }
`
const ViewMode = styled.div `
    display: flex;
    align-items:center;
`
const Border = styled.div `
    width: 1px;
    background-color: ${Colors.secondary};
    height: 40px;
`
const OrderResponsive = styled.div `
    width: 100%;
    min-height: 90px; 
    background-color: ${Colors.white};
    position: relative;
    margin-top: -40px;
    padding-top: 75px;
    display: none;

    @media screen and (max-width: 830px) {
        display: block;
    }
`
const OrderContent = styled.div `
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    margin-top: 5px;
    margin-left: 10px;
    margin-right: 10px;
`
const ItemOrder = styled.div `
    min-width: 40px;
    padding: 15px;
    border: 1px solid rgba(102,102,102, 0.2);
    border-radius: 3px;
    font-size: 13px;
    background-color: #fff;
    margin: 5px;
    color: #66666;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: center;

    &:hover{
        background-color: ${Colors.primary};
        color: #FFF;
    }
`
const Icon = styled.div `
    font-size: 38px;
    line-height: 30px;
    color: ${Colors.primary};
    margin-right: 15px;

    @media screen and (max-width: 830px) {
        display: none;
    }
`



// WEBPACK FOOTER //
// ./src/containers/Box/box.container.js